import { useEffect, useRef } from "react"
import { Session } from "@/types/auth"
import { Honeybadger } from "@honeybadger-io/react"

import { RELEASE_VERSION } from "@/lib/version"

interface UseAppInitProps {
  session?: Session
  supportedBrowser?: boolean | string
}

/**
 * Hook for common app initialization tasks:
 * - Version logging
 * - Early Honeybadger context setting
 * Shared between WebApp and MinimalApp
 */
export function useAppInit({ session, supportedBrowser }: UseAppInitProps) {
  // Log version once on init
  const init = useRef(false)
  useEffect(() => {
    if (!init.current) {
      init.current = true
      console.debug("App Version:", RELEASE_VERSION ?? "NOT_SET")
    }
  }, [])

  // Set Honeybadger context early
  useEffect(() => {
    Honeybadger.setContext({
      user_id: session?.user?.uuid,
      version: RELEASE_VERSION,
      supported_browser: supportedBrowser,
    })
  }, [session, supportedBrowser])
}
